/*global http filterPagination formHelper pagination scrollToElement*/
const searchFilter = {
	el: {
		body: document.body,
		modal: document.querySelector('.modal'),
		filterForm: document.querySelectorAll('.js-filter'),
		filterModal: document.querySelector('.js-filter-modal'),
		filterFormContacts: document.querySelector('.js-filter.contacts'),
		filterFormEvents: document.querySelector('.js-filter.events'),
		filterFormNews: document.querySelector('.js-filter.news'),
		filterFormPublications: document.querySelector('.js-filter.publications'),
		filterFormProjects: document.querySelector('.js-filter.projects'),
		filterFormTeachers: document.querySelector('.js-filter.teachers')
	},

	vars: {
		timer: '',
		currentPage: 1,
		hasCleared: false
	},

	fxFilterResults(element) {
		const searchContainer = element.closest('.js-search') ? element.closest('.js-search') : element.closest('.modal').previousElementSibling,
			form = element.classList.contains('js-filter-modal') ? element : searchContainer.nextElementSibling ? searchContainer.nextElementSibling.querySelector('.js-filter-modal') : '',
			input = searchContainer.querySelector('.js-autocomplete'),
			term = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-search-term') ? searchContainer.nextElementSibling.querySelector('.js-search-term') : '',
			range = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-range') ? searchContainer.nextElementSibling.querySelector('.js-range') : '',
			rangeStart = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-range') ? searchContainer.nextElementSibling.querySelector('.js-range-value-start') : '',
			rangeEnd = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-range') ? searchContainer.nextElementSibling.querySelector('.js-range-value-end') : ''

		searchContainer.nextElementSibling && term ? term.value = input.value : ''
		searchContainer.nextElementSibling && range && range.noUiSlider ? rangeStart.value = range.noUiSlider.get()[0] : ''
		searchContainer.nextElementSibling && range && range.noUiSlider ? rangeEnd.value = range.noUiSlider.get()[1] : ''

		const callback = response => this.fxFilterCallback(response, element),
			formData = !element.classList.contains('teachers') || !element.classList.contains('contacts') ? formHelper.fxFormToJson(form) : null

		http.fxPost(searchContainer.querySelector('.js-filter').getAttribute('action'), formData, callback)
	},

	fxFilterCallback(response, element, page) {
		const data = response.data,
			searchContainer = element.closest('.js-search') ? element.closest('.js-search') : element.closest('.modal').previousElementSibling,
			filterType = searchContainer.querySelector('.js-filter'),
			noResults = filterType.dataset.msgNoResults,
			paginationList = searchContainer.querySelector('.pagination__list'),
			selectorContainer = filterType.classList.contains('teachers') || filterType.classList.contains('contacts') ? '.card-avatar' : filterType.classList.contains('publications') ? '.search-results' : '.media__list'

		//close modal
		this.el.modal ? this.el.modal.classList.remove('is-modal-open') : ''
		this.el.body.classList.remove('no-scroll-hidden')

		//pagination load
		if (page === undefined) {
			pagination.fxPaginationHelper(response, paginationList)
			if (data.pagination.length > pagination.vars.maxPaginationItem)
				paginationList.querySelectorAll(`.pagination__item:nth-of-type(n+${pagination.vars.maxPaginationItem+1}`).forEach(el => el.classList.add('is-hidden'))
		}

		searchContainer.querySelector(selectorContainer).innerHTML = ''

		//numberOfResults
		searchContainer.querySelector('.js-total-results').textContent = data.numberOfResults

		if (data.results.length === 0) {
			searchContainer.querySelector('.pagination').style.display = 'none'
			searchContainer.querySelector(selectorContainer).innerHTML = noResults
		}

		else {
			data.results.forEach((el, i) => {

				//parsing date
				const date = new Date(el.date),
					formattedDate = new Date(date).toLocaleDateString(),
					getShortMonth = date.toLocaleDateString(filterType.dataset.language, { month: 'short' }).slice(0, 3),
					getMonth = date.toLocaleDateString(filterType.dataset.language, { month: 'long' }),
					getShortYear = date.getFullYear() % 100,
					getHours = `${(date.getHours()<10?'0':'')}${date.getHours()}`,
					getMinutes = `${(date.getMinutes()<10?'0':'')}${date.getMinutes()}`,
					//AM/PM - start
					ampm = getHours >= 12 ? 'p.m.' : 'a.m.',
					getampmHours = (getHours % 12) || 12,
					ampmTime = `${getampmHours}:${getMinutes} ${ampm}`,
					//AM/PM - end
					shortHour = document.documentElement.lang === 'pt' ? `${getHours}h${getMinutes}` : `${ampmTime}`,
					getTime = getHours === '00' && getMinutes === '00' ? '' : `<h4 class='media__content--flex'><svg class='media__content-icon' xmlns='http://www.w3.org/2000/svg'><path d='M12 4a8 8 0 110 16 8 8 0 010-16zm0 2a6 6 0 100 12 6 6 0 000-12zm1 1v4.58l2.54 2.539v.002l-1.41 1.409L11 12.401V7h2z' fill='#bed62f' fill-rule='evenodd'></path></svg><span class="media__content-icon-text">${el.fullDate?el.fullDate:shortHour}</span></h4>`

				//API values check
				const target = el.link && el.link.url ? (el.link.target === '_blank' ? el.link.target : '_self') : '',
					time = filterType.classList.contains('events') ? `<time class='media__aside' datetime='${formattedDate}'><span class='media__aside-large beta'>${date.getDate()}</span><span class='media__aside-copy epsilon'>${getShortMonth} '${getShortYear}</span></time>` : '',
					category = el.category && el.category.length ? `<div class='media__content-info epsilon'><span class='media__content-copy-bg'>${el.category}</span></div>` : '',
					location = el.location && el.location.length ? `<h4 class='media__content--flex'><svg class='media__content-icon' xmlns='http://www.w3.org/2000/svg'><path d='M12 3a7 7 0 017 7c0 5-5 11-7 11s-7-6-7-11a7 7 0 017-7zm0 2a5 5 0 00-5 5c0 1.823.916 4.142 2.384 6.222.645.913 1.347 1.703 1.977 2.242.219.186.417.332.582.434l.057.032.057-.032c.124-.076.266-.178.422-.302l.16-.132c.63-.54 1.332-1.329 1.977-2.242C16.084 14.142 17 11.823 17 10a5 5 0 00-5-5zm0 2a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2z' fill='#bed62f' fill-rule='evenodd'></path></svg><span class="media__content-icon-text">${el.location}</span></h4>` : '',
					content = filterType.classList.contains('events') ? `${getTime}${location}` : el.description && el.description.length ? `<h4 class="media__content-copy">${el.description}</h4>` : '',
					link = el.link && el.link.url ? `<a class='media__content-link arrow-animate' target=${target} href='${el.link.url}'>${el.link.name}<svg class='button-icon-relative' xmlns='http://www.w3.org/2000/svg'><path d='M14.5 8H17l3 4-3 4h-2.5l3-4-3-4z' fill-rule='evenodd' fill='#2D3134'></path><path class='arrow-hovered' d='M18 13H4v-2h14v2z' fill-rule='evenodd' fill='#2D3134'></path></svg></a>` : '',
					linkCard = el.link && el.link.url ? `<a class='card-avatar__link arrow-animate' href='${el.link.url}'>${el.link.name}<svg class='button-icon-relative' xmlns='http://www.w3.org/2000/svg'><path d='M14.5 8H17l3 4-3 4h-2.5l3-4-3-4z' fill-rule='evenodd' fill='#2D3134'></path><path class='arrow-hovered' d='M18 13H4v-2h14v2z' fill-rule='evenodd' fill='#2D3134'></path></svg></a>` : '',
					emailCard = el.email ? `<a class='card-avatar__link' href='mailto:${el.email}'>${el.email}</a>` : ''

				//show Elements
				if (filterType.classList.contains('events') || filterType.classList.contains('projects')) {
					searchContainer.querySelector('.media__list').innerHTML +=
						`
							<li class='media__item columns-2'>
								<div class='media__content'>
									<figure class='media__figure'>
										<img class='media__image img-full-width' src='${el.image}' alt='${el.title}'>
									</figure>
									${time}
									<div class='media__content-block'>
										${category}
										<h3 class='media__content-heading zeta'>${el.title}</h3>
										${content}
										${link}
									</div>
								</div>
							</li>
						`
				}

				else if (filterType.classList.contains('news')) {
					searchContainer.querySelector('.media__list').innerHTML +=
						`
							<li class='media__item columns-2 ${i===0?'media__item--first':''}'>
								<div class='media__content'>
									<figure class='media__figure'>
										<img class='media__image img-full-width' src='${el.image}' alt='${el.title}'>
									</figure>
									<div class='media__content-block'>
										<div class='media__content-info epsilon'>
											<span class='media__content-text'>
												<time class='media__time' datetime='${formattedDate}'>${date.getDate()} ${getMonth}, ${date.getFullYear()}</time>
											</span>
											${el.category ?`<span class='media__content-copy-bg'>${el.category}</span>` : ''}
										</div>
										<h3 class='media__content-heading zeta'>${el.title}</h3>
										<h4 class='media__content-copy'>${el.description}</h4>
										${link}
									</div>
								</div>
							</li>
						`
				}

				else if (filterType.classList.contains('publications')) {
					searchContainer.querySelector('.search-results').innerHTML +=
						`
							<article class="search-results__article">
								<h2 class="search-results__heading gamma">${el.title}</h2>
								<h3 class="search-results__posheading">${el.description}.</h3>
							</article>
						`
				}

				else {
					searchContainer.querySelector('.card-avatar').innerHTML +=
						`
							<li class='card-avatar__item columns-3'>
								<div class='card-avatar__wrap'>
									<figure class='card-avatar__figure'>
										<img class='card-avatar__image img-full img-circle' src='${el.image}' alt='${el.name}' data-object-fit='cover'>
									</figure>
									<div class='card-avatar__content'>
										<div class='card-avatar__heading gamma'>${el.name}</div>
										<div class='card-avatar__posheading'>${el.role}</div>
										${emailCard}
										${linkCard}
									</div>
								</div>
							</li>
						`
				}
			})
			scrollToElement.fxScrollTo(document.querySelectorAll('.pagination__item, .pagination__button'), this)
		}
	},

	fxClearSearch(el) {
		const searchContainer = el.closest('.js-search') ? el.closest('.js-search') : el.closest('.modal').previousElementSibling,
			clearButton = searchContainer.querySelector('.js-search-clean'),
			range = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-range') ? searchContainer.nextElementSibling.querySelector('.js-range') : ''

		clearButton.addEventListener('click', e => {
			this.vars.hasCleared = true
			e.currentTarget.removeAttribute('style')
			el.reset()
			this.el.filterModal ? this.el.filterModal.reset() : ''
			searchContainer.nextElementSibling && range && range.noUiSlider ? range.noUiSlider.reset() : ''
			this.el.filterForm.forEach(el => this.fxFilterResults(el))
		})
	},

	fxGetResultsOnEvents(el, endpoint) {
		const searchContainer = el.closest('.js-search') ? el.closest('.js-search') : el.closest('.modal').previousElementSibling,
			input = searchContainer.querySelector('.js-autocomplete')

		input.addEventListener('keydown', e => {
			if (e.key === 'Enter') {
				e.preventDefault()
				if (input.value.length > 3)
					this.fxSearch(el, endpoint)
			}
		})

		if (!searchContainer.querySelector('.js-search-filter')) return

		searchContainer.querySelector('.js-search-filter').addEventListener('click', e => {
			e.preventDefault()
			this.fxSearch(el, endpoint)
		})
	},

	fxAutocomplete(el, endpoint) {
		const searchContainer = el.closest('.js-search') ? el.closest('.js-search') : el.closest('.modal').previousElementSibling,
			clearButton = searchContainer.querySelector('.js-search-clean'),
			input = searchContainer.querySelector('.js-autocomplete'),
			term = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-search-term') ? searchContainer.nextElementSibling.querySelector('.js-search-term') : ''

		input.addEventListener('input', () => {
			if (input.value.length >= 3) {
				input.nextElementSibling.style.display = 'block'
				clearTimeout(this.vars.timer)
				this.vars.timer = setTimeout(() => this.fxSearch(el, endpoint), 1000)
			}
			else {
				clearButton.removeAttribute('style')

				if (input.value.length === 0) {
					searchContainer.nextElementSibling && term ? term.value = '' : ''
					this.el.filterForm.forEach(el => this.fxFilterResults(el))
				}
			}
		})
	},

	fxSearch(element, endpoint) {
		const searchContainer = element.closest('.js-search') ? element.closest('.js-search') : element.closest('.modal').previousElementSibling,
			form = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-filter-modal') ? searchContainer.nextElementSibling.querySelector('.js-filter-modal') : element,
			input = searchContainer.querySelector('.js-autocomplete'),
			term = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-search-term') ? searchContainer.nextElementSibling.querySelector('.js-search-term') : '',
			range = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-range') ? searchContainer.nextElementSibling.querySelector('.js-range') : '',
			rangeStart = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-range') ? searchContainer.nextElementSibling.querySelector('.js-range-value-start') : '',
			rangeEnd = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-range') ? searchContainer.nextElementSibling.querySelector('.js-range-value-end') : ''

		searchContainer.nextElementSibling && term ? term.value = input.value : ''
		searchContainer.nextElementSibling && range && range.noUiSlider ? rangeStart.value = range.noUiSlider.get()[0] : ''
		searchContainer.nextElementSibling && range && range.noUiSlider ? rangeEnd.value = range.noUiSlider.get()[1] : ''

		const callback = response => this.fxFilterCallback(response, element)
		http.fxPost(endpoint, formHelper.fxFormToJson(form), callback)
	},

	init() {
		if (this.el.filterFormEvents) {
			this.fxClearSearch(this.el.filterFormEvents)
			this.fxAutocomplete(this.el.filterFormEvents, this.el.filterFormEvents.getAttribute('action'))
			this.fxGetResultsOnEvents(this.el.filterFormEvents, this.el.filterFormEvents.getAttribute('action'))
			this.fxFilterResults(this.el.filterFormEvents)
			filterPagination.fxFilterPaginationItemHelper('.events', this.el.filterFormEvents, this.el.filterFormEvents.getAttribute('action'))
			filterPagination.fxFilterNavigationHelper('.events', this.el.filterFormEvents.getAttribute('action'), this.el.filterFormEvents)
		}

		else if (this.el.filterFormNews) {
			this.fxClearSearch(this.el.filterFormNews)
			this.fxAutocomplete(this.el.filterFormNews, this.el.filterFormNews.getAttribute('action'))
			this.fxGetResultsOnEvents(this.el.filterFormNews, this.el.filterFormNews.getAttribute('action'))
			this.fxFilterResults(this.el.filterFormNews)
			filterPagination.fxFilterPaginationItemHelper('.news', this.el.filterFormNews, this.el.filterFormNews.getAttribute('action'))
			filterPagination.fxFilterNavigationHelper('.news', this.el.filterFormNews.getAttribute('action'), this.el.filterFormNews)
		}

		else if (this.el.filterFormProjects) {
			this.fxClearSearch(this.el.filterFormProjects)
			this.fxAutocomplete(this.el.filterFormProjects, this.el.filterFormProjects.getAttribute('action'))
			this.fxGetResultsOnEvents(this.el.filterFormProjects, this.el.filterFormProjects.getAttribute('action'))
			this.fxFilterResults(this.el.filterFormProjects)
			filterPagination.fxFilterPaginationItemHelper('.projects', this.el.filterFormProjects, this.el.filterFormProjects.getAttribute('action'))
			filterPagination.fxFilterNavigationHelper('.projects', this.el.filterFormProjects.getAttribute('action'), this.el.filterFormProjects)
		}

		else if (this.el.filterFormTeachers) {
			this.fxClearSearch(this.el.filterFormTeachers)
			this.fxAutocomplete(this.el.filterFormTeachers, this.el.filterFormTeachers.getAttribute('action'))
			this.fxGetResultsOnEvents(this.el.filterFormTeachers, this.el.filterFormTeachers.getAttribute('action'))
			this.fxFilterResults(this.el.filterFormTeachers)
			filterPagination.fxFilterPaginationItemHelper('.teachers', this.el.filterFormTeachers, this.el.filterFormTeachers.getAttribute('action'))
			filterPagination.fxFilterNavigationHelper('.teachers', this.el.filterFormTeachers.getAttribute('action'), this.el.filterFormTeachers)
		}
		else if (this.el.filterFormContacts) {
			this.fxClearSearch(this.el.filterFormContacts)
			this.fxAutocomplete(this.el.filterFormContacts, this.el.filterFormContacts.getAttribute('action'))
			this.fxGetResultsOnEvents(this.el.filterFormContacts, this.el.filterFormContacts.getAttribute('action'))
			this.fxFilterResults(this.el.filterFormContacts)
			filterPagination.fxFilterPaginationItemHelper('.contacts', this.el.filterFormContacts, this.el.filterFormContacts.getAttribute('action'))
			filterPagination.fxFilterNavigationHelper('.contacts', this.el.filterFormContacts.getAttribute('action'), this.el.filterFormContacts)
		}
		else if (this.el.filterFormPublications) {
			this.fxClearSearch(this.el.filterFormPublications)
			this.fxAutocomplete(this.el.filterFormPublications, this.el.filterFormPublications.getAttribute('action'))
			this.fxGetResultsOnEvents(this.el.filterFormPublications, this.el.filterFormPublications.getAttribute('action'))
			this.fxFilterResults(this.el.filterFormPublications)
			filterPagination.fxFilterPaginationItemHelper('.publications', this.el.filterFormPublications, this.el.filterFormPublications.getAttribute('action'))
			filterPagination.fxFilterNavigationHelper('.publications', this.el.filterFormPublications.getAttribute('action'), this.el.filterFormPublications)
		}
	}
}

searchFilter.init()